import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';

import { PerfilEnum } from '../base/enum/perfil';
import { Usuario } from '../base/vo/usuario';
import { AutenticacaoService } from './autenticacao.service';


@Injectable()
export class AuthGuardService implements CanActivate {

  constructor(private router: Router, private autenticacaoService: AutenticacaoService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    let retorno: boolean;
    const usuario: Usuario = this.autenticacaoService.usuarioLogado;

    retorno = false;
    if (usuario != null) {
      switch (usuario.perfil) {
        case PerfilEnum.ADMIN:
          retorno = this.isUrlAdmin(state.url);
          break;
        case PerfilEnum.MARKETING:
          retorno = this.isUrlMarketing(state.url);
          break;
        case PerfilEnum.PRESTADOR:
          retorno = !this.isUrlAdmin(state.url);
          break;
        default:
          retorno = false;
      }
    }

    if (!retorno) {
      this.router.navigate(['login']);
    }

    return retorno;
  }

  private isUrlAdmin(url: string): boolean {
    return url.indexOf('/admin/configs') > -1;
  }

  private isUrlMarketing(url: string): boolean {
    if (this.isUrlAdmin(url)) {
      return false;
    }

    return url.indexOf('/admin') > -1;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/autenticacao/auth-guard.service.ts